/**
 * Public "about / prices / legal" strip, visible without signing in (sign-in gate + Title). Lists what Hand Egg is,
 * the web coin packs with their USD prices (from COIN_PACKS; only while `WEB_COIN_PURCHASES_ENABLED`, otherwise
 * `WEB_COINS_NOTE`), the seller and the legal links. /terms, /privacy and
 * /refund are 301s to the legal site, handled by the handegg-web Worker.
 */
import './public-info.css';
import { COIN_PACKS, WEB_COIN_PURCHASES_ENABLED, WEB_COINS_NOTE } from '@hf/shared';

const SUPPORT = 'support@hustlemania.dev';
const stop = (e: Event): void => e.stopPropagation();

export function PublicInfo({ class: cls = '' }: { class?: string }) {
  return (
    <footer class={`hf-pubinfo ${cls}`} data-testid="public-info" onPointerDown={stop} onKeyDown={stop}>
      {WEB_COIN_PURCHASES_ENABLED ? (
        <>
          <p class="hf-pubinfo__what">
            <b>Hand Egg</b> is a free arcade football game. Optional coin packs (cosmetic only):
          </p>
          <ul class="hf-pubinfo__packs">
            {COIN_PACKS.map((p) => (
              <li key={p.id}>
                <span class="n">{p.name}</span> <span class="p">${p.usd.toFixed(2)}</span>{' '}
                <span class="c">{p.coins.toLocaleString('en-US')} coins</span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p class="hf-pubinfo__what">
          <b>Hand Egg</b> is a free arcade football game. {WEB_COINS_NOTE}
        </p>
      )}
      <p class="hf-pubinfo__legal">
        Sold by Amir Angel (<span lang="he">עוסק מורשה</span>), HustleMania
        {WEB_COIN_PURCHASES_ENABLED ? ' · Web payments by Paddle.com' : ''} ·{' '}
        <a href="/terms" target="_blank" rel="noopener">
          Terms
        </a>{' '}
        ·{' '}
        <a href="/privacy" target="_blank" rel="noopener">
          Privacy
        </a>{' '}
        ·{' '}
        <a href="/refund" target="_blank" rel="noopener">
          Refund Policy
        </a>{' '}
        · <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a>
      </p>
    </footer>
  );
}
